
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { amplifyService } from '@kasasa/kloans-common-ui/dist/consumer-app/services/amplify';
import { CodeValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { CognitoUser } from '@aws-amplify/auth';
import { ProductInviteType } from '@/login/enums/ProductInviteType';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component({
	validations: {
		code: CodeValidation.validations(6),
	},
})
export default class MFA extends Vue {
	@Prop({ default: null })
	profileConnectionToken!: string | null;

	TEST_ID = 'Kloans-Loan-MFA';

	public trustBrowser = false;

	public code = '';

	public submitBtn = true;

	loading = false;

	private cognitoUser!: CognitoUser;

	public async beforeMount(): Promise<void> {
		await amplifyService.initialize();
		this.cognitoUser = await amplifyService.getCognitoUser();
		if (!this.cognitoUser) {
			this.$router.push({ name: 'login' });
		}
	}

	get codeErrors() {
		return CodeValidation.errors(this, 'code', '6');
	}

	public validate() {
		this.$v.code.$touch();
		if (!this.$v.$invalid) {
			this.$store.dispatch('login/clearError');
			this.submitBtn = false;
			this.submitMFA();
		}
	}

	public async submitMFA() {
		this.$store.dispatch('login/clearError');
		this.submitBtn = false;
		this.loading = true;
		await amplifyService.submitMFA(
			this.cognitoUser,
			this.code,
			this.trustBrowser, {
				onSuccess: this.successCallback,
				onFailure: this.error,
			},
		);
	}

	public error(message: string) {
		this.$store.dispatch('login/showError', message);
		this.submitBtn = true;
		this.loading = false;
	}

	private successCallback = (): void => {
		if (this.profileConnectionToken) {
			this.redirectToProductInviteViewForProfileConnection();
			return;
		}
		window.location.href = '/#/profile/accounts';
	};

	private redirectToProductInviteViewForProfileConnection(): void {
		this.$router.push({
			name: 'kasasaLoanInviteVerification',
			params: {
				token: this.profileConnectionToken ?? '',
			},
			query: {
				type: ProductInviteType.CONNECT_EXISTING_PROFILE.toString(),
			},
		});
	}
}
